import { render } from "./VideoPlayerSettings.vue?vue&type=template&id=710eb0aa&ts=true"
import script from "./VideoPlayerSettings.vue?vue&type=script&lang=ts"
export * from "./VideoPlayerSettings.vue?vue&type=script&lang=ts"

import "./VideoPlayerSettings.vue?vue&type=style&index=0&id=710eb0aa&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__